import React from "react";
import { connect } from "react-redux";

import ComponentWrapper from "../../common/ComponentWrapper";

import ChatContainer from "../../common/ChatContainer/ChatContainer";
import BroadcasterPage from "../Broadcaster/BroadcasterPage";


class CustomWrapperPage extends ComponentWrapper {
  state = {
    addon: null,
  }

  componentDidMount() {
    const { addon } = this.props.match.params;

    if (addon) this.setState({ addon });
  }


  render () {
    const { addon } = this.state;

    return (
      <div>
        {(addon && addon === 'chat') ?
          <ChatContainer addon={true}/>
        : addon === 'broadcaster' ?
          <BroadcasterPage/>

        : null}
      </div>
      

    )
  }
}

export default connect((state) => ({ jels: state.jels }), {})((CustomWrapperPage));
